module.exports = __webpack_public_path__ + "img/icon_seen.b0b64dc8.svg";